<template>
  <div class="account-login-form">
    <div>
      <div class="glob-error">
        <div class="error-box-g" v-if="resError.hasError">
          <div>
            <span class="warn-icon">
              <unex-icon svg="warn"></unex-icon>
            </span>
            <span>{{ resError.errorG }}</span>
          </div>
        </div>
      </div>
      <form class="login-form" ref="loginForm" @keyup.enter="login()">
        <div class="input-line">
          <div class="form-label">{{ $t("frame.user_name") }}</div>
          <el-input
            :class="{
              'v-error':
                validaError.username ||
                (resError.errorM && !validaError.username)
            }"
            type="text"
            :placeholder="$t('frame.please_enter')"
            v-model="account.username"
            name="username"
            @blur="handleInputUsername"
            @change="clearError('password')"
          ></el-input>
          <transition name="heightchange">
            <div class="error-box" v-if="validaError.username">
              <span>{{ validaError.username }}</span>
            </div>
          </transition>
          <transition name="heightchange">
            <div
              class="error-box"
              v-if="resError.errorM && !validaError.username"
            >
              <span>{{ resError.errorM }}</span>
            </div>
          </transition>
        </div>
        <div class="input-line">
          <div class="form-label">{{ $t("frame.password") }}</div>
          <el-input
            style="display:none"
            id="loginPassword"
            type="text"
            auto-complete="new-password"
            @keyup.native="setType"
          >
          </el-input>
          <el-input
            :class="{
              'v-error': validaError.password
            }"
            :placeholder="$t('frame.please_enter')"
            type="password"
            auto-complete="new-password"
            v-model="account.password"
            @blur="validate('password')"
            @change="clearError('password')"
          ></el-input>
          <transition name="heightchange">
            <div class="error-box" v-if="validaError.password">
              <span>{{ validaError.password }}</span>
            </div>
          </transition>
        </div>

        <div class="input-line">
          <div class="captcha-input-wrap">
            <div class="form-label">{{ $t("frame.pic_code") }}</div>
            <el-input
              :class="{
                'v-error': validaError.loginCode
              }"
              :placeholder="$t('frame.please_enter')"
              v-model="account.loginCode"
              name="loginCode"
              @blur="validate('loginCode')"
              @change="clearError('password')"
            ></el-input>
            <div class="captchaUrl-wrap">
              <el-tooltip popper-class="login-tooltip" placement="top">
                <div
                  slot="content"
                  class="tooltip-content"
                  style=" color: #666666 ;"
                >
                  {{ $t("frame.renew_info") }}
                </div>
                <img
                  v-if="captchaUrlLoad"
                  :src="captchaUrl"
                  @error="getCaptcha"
                  class="validate-code"
                  @click="getCaptcha"
                />
                <img v-else :src="captchaUrl" @click="getCaptcha" />
              </el-tooltip>
            </div>
          </div>
          <transition name="heightchange">
            <div class="error-box" v-if="validaError.loginCode">
              <span>{{ validaError.loginCode }}</span>
            </div>
          </transition>
          <transition name="heightchange">
            <div
              class="error-box"
              v-if="resError.loginCode && !validaError.username"
            >
              <span>{{ resError.loginCode }}</span>
            </div>
          </transition>
        </div>


        <!-- 短信验证码 by租户开启 双因登录-->
        <div class="input-line" v-if="is2FA">
          <div class="captcha-input-wrap">
            <div class="form-label">
              {{ $t("frame.code_validate") }}
            </div>
            <el-input
              :class="{
                'v-error': validaError.code
              }"
              :placeholder="$t('frame.please_enter')"
              v-model="account.code"
              autocomplete="off"
              name="l-code"
              @blur="validate('code')"
              @change="clearError('mobile')"
            ></el-input>
            <div class="captchaUrl-wrap warp-code" @click="getMobileCode">
              <span>{{ pcodetext }}</span>
            </div>
          </div>
          <transition name="heightchange">
            <div class="error-box">
              <span>{{ validaError.code }}</span>
            </div>
          </transition>
          <transition name="heightchange">
            <div
              class="error-box"
              v-if="resError.codeError && !validaError.username"
            >
              <span>{{ resError.codeError }}</span>
            </div>
          </transition>
        </div>


        <div style="text-align: left;">
          <el-checkbox v-model="account.rememberMe">{{
            $t("frame.automaticlogin")
          }}</el-checkbox>
        </div>

        <el-button class="submit" @click="login" type="primary">
          {{ loginStauts }}
          <i class="unex-icon-arrow-right"></i>
        </el-button>
      </form>
      <div class="forget-span">
        <span @click="setHref('mobile')" class="m-login">{{
          $t("frame.mobile_login")
        }}</span>
        <span @click="setHref('forget')" class="f-des">{{
          $t("frame.forget_password")
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import cookie from "js-cookie";
import debounce from "lodash/debounce";
import { mapState, mapMutations, mapActions } from "vuex";
import { Base64 } from "js-base64";
const CryptoJS = require('crypto-js')

export default {
  data() {
    return {
      loginStauts: this.$t("frame.sign_in"),
      pcodetext: this.$t("frame.get_validate"),
      is2FA: false, // 是否开启双因登录 校验手机短信
      pcodeCount: 1,
      account: {
        username: cookie.get("username"), // "",
        password: cookie.get("password")
          ? Base64.decode(cookie.get("password"))
          : "", // "",
        loginCode: "",
        code: "", // 短信验证码
        codeKey: "",
        rememberMe: false,
        newpassword: null,
        confirmPassword: null
      },
      validaError: {
        username: "",
        password: "",
        loginCode: "",
        codeError: "", // 短信验证码
      },
      resError: {
        hasError: false,
        errorM: "",
        errorG: "",
        code: "",
        href: "",
        loginCode: ""
      }
    };
  },
  mounted() {
    // this.getCaptcha();
  },
  computed: {
    ...mapState({
      captchaUrl: state => state.frame.login.captchaUrl,
      captchaUrlLoad: state => state.frame.login.captchaUrlLoad
    }),
  },
  methods: {
    ...mapMutations({
      setLoginType: "frame/login/setLoginType"
    }),
    ...mapActions({
      getCaptcha: "frame/login/getCaptcha"
    }),
    
    async handleInputUsername(){
      const flag = this.validate('username')
      if(flag){ // 账号验证通过则检验是否需要双因登录
        this.is2FA = await this.getIs2FAResult()
      }
    },
    // 是否为双因登录
    async getIs2FAResult(){
     try{
      const params = {
        username: this.account.username
      }
      let { success, data=false } = await this.$store.dispatch("frame/needSmsCaptcha", params);
      return success && data
     } catch(e){
       console.log(e)
       return false
     }
    },
    setHref(type) {
      this.setLoginType(type);
      this.getCaptcha();
    },
    beforeLogin() {
      for (let item in this.resError) {
        this.resError[item] = "";
      }
      this.resError.hasError = false;
    },
    login() {
      let self = this;
      self.beforeLogin();
      const aesMinEncrypt = word => {
        const _word = CryptoJS.enc.Utf8.parse(word),
            _key = CryptoJS.enc.Utf8.parse("v-QM.Jrg#eSk(b0f"),
            _iv = CryptoJS.enc.Utf8.parse("e@wj9N)Nxud$SrhA");
        const encrypted = CryptoJS.AES.encrypt(_word, _key, {
          iv: _iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      }

      let loginFn = async function() {
        self.loginStauts = self.$t("frame.log_in");
        const params = self.account;
        // params.password = aesMinEncrypt(params.password)
        let res = self.$store.dispatch("frame/login", params);
        res
          .then(res => {
            self.loginStauts = self.$t("frame.sign_in");
            if (!res.success) {
              self.afterError(res);
              setTimeout(() => {
                self.resError.hasError = false;
              }, 3000);
            } else {
              self.$emit("afterLogin", res);
            }
          })
          .catch(err => {
            console.log(err);
          });
      };
      if (this.validate()) {
        this.debounce(loginFn);
      }
    },
    debounce: debounce(
      (...args) => {
        // 防抖
        let fn = Array.prototype.shift.call(args);
        fn();
      },
      1000,
      { leading: true }
    ),
    afterError(res) {
      console.log('afterError');
      let self = this;
      self.getCaptcha();
      self.resError.code = res.code;

      let resCodeArr = [
        "d*0308$",
        "d*0309$",
        "d*0303$",
        "d*0310$",
        "d*0302$",
        "d*0103$",
        "d*3002$"
      ];

      //获取密码规则
      self.$emit("setDialog", res.code.includes(2117));

      let errWhere = resCodeArr.some(cell => {
        let reg = new RegExp(cell);
        return reg.test(res.code);
      });

      if (errWhere) {
        self.resError.errorG = res.message;
        self.resError.hasError = true;
      } else if (/\d*0503/.test(res.code)) {
        self.resError.loginCode = res.message;
      } else if (res.code.includes(2110)) {
        self.resError.codeError = res.message;
      } else if (!res.code.includes(2117)) {
        self.resError.errorM = res.message;
      } 
    },
    setIntervalTime() {
      if (this.pcodeCount == 1) {
        window.clearInterval(this.InterValObj); //停止计时器
        this.pcodetext = this.$t("frame.get_validate");
      } else {
        this.pcodeCount--;
        this.pcodetext = this.pcodeCount + "s" + this.$t("frame.Re_acquire");
      }
    },
        //获取短信验证码
    async getMobileCode() {
      if (this.pcodeCount === 1 && this.account.username) {
        this.pcodeCount = 60;
        this.InterValObj = window.setInterval(this.setIntervalTime, 1000);
        this.resError.codeError = "";
        this.resError.loginCode = ""
        let res = await this.$store.dispatch("frame/getMobileCode", {
          userAccount: this.account.username, // 传入账号
          imageCode: this.account.loginCode
        });
        if (!res.success) {
          this.getCaptcha();
          let code = res.code.substring(4);
          
          if (code == 2112 || code == 2113 || code == 2127) {
            this.resError.codeError = res.message;
          } else if (/\d*0503/.test(res.code)) {
            this.resError.loginCode = res.message;
          }else if (code == 2016) {
            this.$message({
              message: res.message,
              type: "error",
              center: true,
              duration: 2000
            });
          }
          window.clearInterval(this.InterValObj); //停止计时器
          this.pcodeCount = 1;
          this.pcodetext = this.$t("frame.get_validate");
        } else {
          this.resError.hasError = true;
          this.resError.errorG = this.$t("frame.please_check");
          setTimeout(() => {
            this.resError.hasError = false;
          }, 3000);
        }
      }
    },
    //密码框类型设置
    setType(event) {
      if (event.target.value.length <= 0) {
        event.target.type = "text";
      } else {
        event.target.type = this.passwordType;
      }
    },
    clearError() {
      this.resError.hasError = false;
    },
    validate(name) {
      let arr = [1, 1, 1,1];
      if (name === "username" && !this.account.username) {
        this.validaError.username = this.$t("frame.user_name_error_msg");
        arr[0] = 0;
      } else if (name === "username" && this.account.username) {
        this.validaError.username = "";
      }
      if (name === "password" && !this.account.password) {
        this.validaError.password = this.$t("frame.password_error_msg");
        arr[1] = 0;
      } else if (name === "password" && this.account.password) {
        this.validaError.password = "";
      }
      if (name === "loginCode" && !this.account.loginCode) {
        this.validaError.loginCode = this.$t("frame.pic_code_error_msg");
        arr[2] = 0;
      } else if (name === "loginCode" && this.account.loginCode) {
        this.validaError.loginCode = "";
      } 
      if (name === "code" && this.is2FA){
        this.validaError.code =  this.account.code ? '' : this.$t("frame.please_SMS_number");
        arr[3] = this.account.code ? 1 : 0;
      }
      if (!name) {
        if (!this.account.username) {
          this.validaError.username = this.$t("frame.user_name_error_msg");
          arr[0] = 0;
        }
        if (!this.account.password) {
          this.validaError.password = this.$t("frame.password_error_msg");
          arr[1] = 0;
        }
        if (!this.account.loginCode) {
          this.validaError.loginCode = this.$t("frame.pic_code_error_msg");
          arr[2] = 0;
        }
        if (!this.account.code && this.is2FA) {
          this.validaError.code = this.$t("frame.please_SMS_number");
          arr[3] = 0;
        }
      }
      return arr.every(cell => {
        return cell;
      });
    }
  }
};
</script>
